export type AppErrorSource = 'http' | 'runtime';
export type AppErrorKind =
  | 'network'
  | 'timeout'
  | 'unauthorized'
  | 'forbidden'
  | 'notFound'
  | 'validation'
  | 'conflict'
  | 'server'
  | 'backend'
  | 'unexpected';
export type AppErrorPresentation = 'toast' | 'dialog' | 'inline' | 'silent';
export type AppErrorSeverity = 'info' | 'warn' | 'error';

export interface AppValidationErrors {
  readonly [fieldName: string]: string;
}

export interface AppError {
  readonly id: string;
  readonly source: AppErrorSource;
  readonly kind: AppErrorKind;
  readonly severity: AppErrorSeverity;
  readonly presentation: AppErrorPresentation;
  readonly title: string;
  readonly message: string;
  readonly timestamp: string;
  readonly isRetryable: boolean;
  readonly statusCode?: number;
  readonly backendCode?: number | string;
  readonly backendMessage?: string;
  readonly method?: string;
  readonly url?: string;
  readonly validationErrors?: AppValidationErrors;
  readonly cause?: unknown;
}

export function isAppError(value: unknown): value is AppError {
  if (typeof value !== 'object' || value === null) {
    return false;
  }

  const candidate = value as Partial<AppError>;

  return (
    typeof candidate.id === 'string' &&
    typeof candidate.kind === 'string' &&
    typeof candidate.source === 'string' &&
    typeof candidate.message === 'string'
  );
}
